export default __webpack_public_path__ + "static/media/calendar.e0ad26a4.svg";